import Circle from "./color-splashes/Circle.svg"
import HalfCircle from "./color-splashes/HalfCircle.svg"
import Square from "./color-splashes/Square.svg"
import Triangle from "./color-splashes/Triangle.svg"
import CircleFill from "./color-splashes/CircleFill.svg"
import HalfCircleFill from "./color-splashes/HalfCircleFill.svg"
import SquareFill from "./color-splashes/SquareFill.svg"
import TriangleFill from "./color-splashes/TriangleFill.svg"

export default {
    colorSplashes: {
        circle: Circle,
        halfCircle: HalfCircle,
        square: Square,
        triangle: Triangle,
        fullCircle: CircleFill,
        fullHalfCircle: HalfCircleFill,
        fullSquare: SquareFill,
        fullTriangle: TriangleFill
    },
    filledSplashes: {
        fullCircle: CircleFill,
        fullHalfCircle: HalfCircleFill,
        fullSquare: SquareFill,
        fullTriangle: TriangleFill
    }
}